import React from "react";
import {
	TextField,
	Autocomplete,
} from "@mui/material";

import { useField } from "formik";
import Styles from "./MultiSelectDropdown.module.css";



const MultiSelectDropdown = ({
	values,
	setFieldValue,
	options,
	fieldName,
	label,
}) => {
	
	const [field, meta] = useField(fieldName);
	
	const configDateTimePicker = {
		...field,
		fieldName,
		label,
		variant: "outlined",
		fullWidth: true,
		InputLabelProps: {
			shrink: true,
		},
		error: meta && meta.touched && meta.error,
		helperText:
			meta && meta.touched && meta.error ? meta.error : "",
	};

	return (
		<div>
			<Autocomplete
				className={Styles.autoComplete}
				sx={{ width: " 100% " }}
				multiple
				id={`autocomplete-${fieldName}`}
				options={options}
				disableCloseOnSelect
				value={values[fieldName]}
				onChange={(event, newValue) => {
					setFieldValue(fieldName, newValue);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						{...configDateTimePicker}
						variant='outlined'
						label={label}
						placeholder={label}
					/>
				)}
			/>	
		</div>
	);
};

export default MultiSelectDropdown;
